import {License} from '../interfaces/biozoom-api/license';
import {AppDesign, State, StateInterface} from '../interfaces/biozoom-api/app-configuration';
import {environment} from '../../environments/environment';

const hasFlatrateForMeasurement = (
  license: License,
  measurementType: 'aox' | 'aox_precise' | 'hrv' | 'vitality',
): boolean => {
  const flatrate = license?.scanner?.flatrate;
  if (!license?.valid || !flatrate) {
    return false;
  }

  switch (measurementType) {
    case 'aox':
      return !!flatrate.aox;
    case 'aox_precise':
      return !!flatrate.aoxQuick;
    case 'hrv':
      return !!flatrate.hrv;
    case 'vitality':
      return !!flatrate.vitality;
  }
};

export const addMeasurementToLicense =
  (
    measurementType: 'aox' | 'aox_precise' | 'hrv' | 'vitality',
    count: number,
    state: StateInterface,
    setState: ((key: State, val: any) => void),
    save = false,
  ) => {
  const license: License = state?.LICENSE;
  if (!license || !save) {
    return;
  }
  if (hasFlatrateForMeasurement(license, measurementType)) {
    return;
  }
  switch (measurementType) {
    case 'aox':
      license.measurements.aox += count;
      break;
    case 'aox_precise':
      license.measurements.aoxPrecise += count;
      break;
    case 'hrv':
      license.measurements.hrv += count;
      break;
    case 'vitality':
      license.measurements.vitality += count;
      break;
  }
  setState(State.LICENSE, license);
};

const getHeaders = (method: 'get' | 'post') => {
  let jwt = '';
  const stateRaw = localStorage.getItem('persistentValues');
  if (stateRaw) {
    const persistentValues: StateInterface = JSON.parse(stateRaw);
    jwt = persistentValues.JWT;
  }

  const headers = {
    'Access-Control-Allow-Origin': '*',
    Accept: 'application/json; charset=UTF-8',
  };

  if (jwt && jwt !== '' ) {
    headers['Authorization'] = 'Bearer ' + jwt;
  }
  if (method === 'post') {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
};

export const getLicense = async (serial: string, force = false) => {
  const ignore = localStorage.getItem('licenseDataIgnore');
  if (ignore && ignore === 'true' && !force) {
    return;
  }
  const urls = environment.appLicenseUrl ?? [];
  if (urls.length === 0) {
    localStorage.setItem('licenseDataIgnore', 'true');
    localStorage.removeItem('licenseData');
  }
  for (const url of urls) {
    try {
      const resp = await fetch(`${url}/license/app/${serial}`, {
        method: 'GET',
        headers: getHeaders('get'),
        // @ts-ignore
        signal: AbortSignal.timeout(5000)
      });
      if (resp.status === 200) {
        const body: License = await resp.json();
        if (body?.valid) {
          localStorage.setItem('licenseDataIgnore', 'false');
          localStorage.setItem('licenseData', JSON.stringify(body));
          return body;
        } else {
          localStorage.setItem('licenseDataIgnore', 'true');
          localStorage.removeItem('licenseData');
          return;
        }
      } else if (resp.status === 404) {
        localStorage.setItem('licenseDataIgnore', 'true');
        localStorage.removeItem('licenseData');
        return;
      } else {
        continue;
      }
      break;
    } catch (e) {
    }
  }
};

export const sendLicense = async (state: StateInterface): Promise<License | undefined> => {
  const license: License = state.LICENSE;
  if (!license) {
    return;
  }
  const urls = environment.appLicenseUrl ?? [];
  for (const url of urls) {
    try {

      const resp = await fetch(`${url}/license/app`, {
        method: 'POST',
        headers: getHeaders('post'),
        body: JSON.stringify({measurements: license?.measurements ?? {}, serial: state.SCANNER_SERIAL}),
        // @ts-ignore
        signal: AbortSignal.timeout(5000)
      });
      if (resp.status === 200) {
        const body: License = await resp.json();
        if (body?.valid) {
          localStorage.setItem('licenseData', JSON.stringify(body));
          body.measurements = {
            aox: 0,
            aoxPrecise: 0,
            hrv: 0,
            vitality: 0,
          };
          return body;
        } else {
          localStorage.removeItem('licenseData');
        }
      } else if (resp.status === 404) {
        localStorage.removeItem('licenseData');
      } else {
        continue;
      }
      break;
    } catch (e) {
    }
  }
  return;
};
